module.exports = __webpack_public_path__ + "img/icann.f8a0eccd.png";